import { render, staticRenderFns } from "./GoTop.vue?vue&type=template&id=45e000aa&scoped=true&"
import script from "./GoTop.vue?vue&type=script&lang=js&"
export * from "./GoTop.vue?vue&type=script&lang=js&"
import style0 from "./GoTop.vue?vue&type=style&index=0&id=45e000aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e000aa",
  null
  
)

export default component.exports